module.exports = "/_next/static/images/doge-74dfc1d522a606162b40ff526461d2f8.svg";